var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.512.667C2.742.268 3.173 0 3.667 0h6.666c.494 0 .925.268 1.155.667h.845c.737 0 1.334.597 1.334 1.333v2c0 2.149-1.003 3.716-2.813 3.965a4.666 4.666 0 01-3.187 1.988v.714h.666c.737 0 1.334.597 1.334 1.333H4.333c0-.736.597-1.333 1.334-1.333h.666v-.714a4.666 4.666 0 01-3.187-1.988C1.336 7.715.333 6.15.333 4V2C.333 1.264.93.667 1.667.667h.845zM2.333 2h-.666v2c0 1.02.26 1.783.752 2.226a4.691 4.691 0 01-.086-.893V2zm9.334 0v3.333c0 .305-.03.604-.085.893.491-.443.751-1.205.751-2.226V2h-.666zm-8-.667v4a3.333 3.333 0 106.666 0v-4H3.667z",
    fill: "#565459"
  })));
};

export default SvgTrophy;